import {
  testMyHousfyShallowMount,
  myHousfyShallowMount,
} from "@/tests/unit/setup";
import Contact from "@/views/Contact.vue";
import MyHousfyConfig from "@/services/MyHousfyConfig";
import { Country } from "@/enums/Config";

const component = (data = {}) => {
  return myHousfyShallowMount(Contact, {
    data,
  });
};

describe("Contact", () => {
  testMyHousfyShallowMount(Contact);

  describe("phones", () => {
    it("should return the expected phones if country is ES", () => {
      // given
      spyOn(MyHousfyConfig, "country").and.returnValue(Country.ES);
      const expectedPhones = [
        {
          internationalPhone: "+34911237975",
          label: "911 237 975",
          id: "Madrid",
        },
        {
          internationalPhone: "+34931760099",
          label: "931 760 099",
          id: "Barcelona",
        },
      ];
      // when
      const contact = component().vm;
      // then
      expect(contact.phones).toEqual(expectedPhones);
    });
  });
  it("should return the expected phones if country is PT", () => {
    // given
    spyOn(MyHousfyConfig, "country").and.returnValue(Country.PT);

    // when
    const contact = component().vm;
    // then
    expect(contact.phones).toEqual([]);
  });
  it("should return the expected phones if country is IT", () => {
    // given
    spyOn(MyHousfyConfig, "country").and.returnValue(Country.IT);
    // when
    const contact = component().vm;
    // then
    expect(contact.phones).toEqual([]);
  });
});
